/* eslint-disable react/jsx-props-no-spreading, no-undef */
import React, { Suspense } from 'react';

import ReactDOM from 'react-dom';

function renderNode(tag, Comp, node, i) {
  const attrs = Array.prototype.slice.call(node.attributes);
  const props = {
    key: `${tag}-${i}`,
  };

  attrs.forEach((attr) => {
    props[attr.name] = attr.value;
  });

  if (props.class) {
    props.className = props.class;
    delete props.class;
  }

  ReactDOM.render(
    <Suspense fallback={<div />}>
      <Comp {...props} />
    </Suspense>,
    node,
  );
}

function register(tag, Comp) {
  document.createElement(tag);

  const nodes = Array.from(document.getElementsByTagName(tag));
  nodes.map((node, i) => renderNode(tag, Comp, node, i));

  return Comp;
}

export default register;
